import { render, staticRenderFns } from "./UKHomeTop10Titles.vue?vue&type=template&id=02d879d3&scoped=true"
import script from "./UKHomeTop10Titles.vue?vue&type=script&setup=true&lang=ts"
export * from "./UKHomeTop10Titles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UKHomeTop10Titles.vue?vue&type=style&index=0&id=02d879d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d879d3",
  null
  
)

export default component.exports